// shared-components/hooks/useSiteGradients.js
import { useGradient } from "../../web/hooks/useGradient";
import { useWebsite } from "./useWebsite";
import { useTheme } from "@shared/lib/theme";

export function useSiteGradients() {
  const designGradients = useGradient(); // Get all design system gradients
  const { theme } = useTheme();
  const websiteConfig = useWebsite();
  const isDark = theme === "dark";

  // Default site-specific gradients
  const defaultSiteGradients = {
    // UI Elements
    tag1: isDark
      ? "bg-gradient-to-r from-primary-700 to-primary-600"
      : "bg-gradient-to-r from-primary-500 to-primary-400",
    // ... other defaults
  };

  // Flatten nested gradients from config
  const flattenGradients = (obj, prefix = "") => {
    const flattened = {};

    Object.entries(obj).forEach(([key, value]) => {
      const newKey = prefix
        ? `${prefix}${key.charAt(0).toUpperCase() + key.slice(1)}`
        : key;

      if (value && typeof value === "object" && !value.light && !value.dark) {
        // It's a nested object, recurse
        Object.assign(flattened, flattenGradients(value, newKey));
      } else if (value && value.light && value.dark) {
        // It's a gradient with light/dark variants
        flattened[newKey] = isDark ? value.dark : value.light;
      } else {
        // It's a direct value
        flattened[newKey] = value;
      }
    });

    return flattened;
  };

  const siteGradients = websiteConfig?.gradients
    ? flattenGradients(websiteConfig.gradients)
    : {};

  // Return all gradients, with site-specific ones taking precedence
  return {
    ...designGradients, // Include all design system gradients
    ...defaultSiteGradients, // Include default site-level gradients
    ...siteGradients, // Override with site-specific gradients
  };
}
